export default {
      id: "claim-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#claim",
      toString: function () {
        return this.url;
      }
    }